// O ECharts 6 trocou o tema padrão. Para manter a aparência dos gráficos existentes,
// registramos o tema de compatibilidade 'v5' que acompanha o pacote e o usamos como padrão.
import 'echarts/theme/v5.js'

export const DEFAULT_ECHARTS_THEME = 'v5'
